import { Component, Input, OnInit } from '@angular/core';
/**
 * Componente que muestra la vista del itinerario cancelado debido a IROPs (Irregular Operations).
 * 
 * Este componente maneja la información de los segmentos de vuelo cancelados y proporciona detalles
 * sobre los aeropuertos de salida y llegada.
 */
@Component({
    selector: 'itinerary-canceled-irops-view',
    templateUrl: './itinerary-canceled-irops-view.component.html',
    styleUrls: ['./itinerary-canceled-irops-view.component.scss'],
    standalone: false
})
export class ItineraryCanceledIropsViewComponent implements OnInit {


   /** Indica si el vuelo ha sido cancelado */
   isCancel: boolean = true;
  
   /** Segmento de vuelo cancelado */
   @Input() segCancel: any;
   
   /** Información del segmento cancelado */
   segment: any;

  constructor() { }

  ngOnInit() {
    this.segment = this.segCancel || {};
  }
    /**
   * Obtiene el aeropuerto de llegada del segmento cancelado
   */
  get arrivalAirport() {
    return this.segment?.arrivalAirport;
  }
 /**
   * Obtiene el aeropuerto de salida del segmento cancelado
   */
  get departureAirport() {
    return this.segment?.departureAirport;
  }

}
